var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"govuk-back-link",attrs:{"role":"button","aria-label":"go back to the previous screen"}},[_c('strong',[_vm._v("Back")])])}]

export { render, staticRenderFns }